var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-components-bubbles-modal",class:[
    `stream-${_vm.position}`,
    _vm.isEmpty && ['stream--empty', 'stream-components-bubbles-modal--empty']
  ]},[_vm._t("default"),_c('button',{staticClass:"stream-components-bubbles-modal__close",on:{"click":function($event){$event.stopPropagation();return _vm.$emit('close')}}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }